const isNull = function(value): value is null {
  return value === null;
};

export default isNull;
